var MobileDetect = window.MobileDetect || new(require('mobile-detect'))(window.navigator.userAgent);

$().ready(function() {
    $(document).on('click', '[data-youtube-link]', function() {
        var $link = $(this),
            code = $link.attr('data-youtube-link');

        if (code) {
            //deactivated

            if (!$link.is('.playing')) {
                var url = 'https://www.youtube.com/embed/' + code + '?origin=http://blax.ca&showinfo=0&rel=0';
                if (!MobileDetect.mobile()) {//the device will do this anyway
                    url += '&autoplay=1';
                }
                $link.append('<iframe id="ytplayer" type="text/html" src="' + url + '" frameborder="0"/>');
                $link.addClass('playing');

                //The Iframe must be DELETED! DELETED! DELETED!
                $link.one('delete', function() {
                    var $this = $(this);
                    if ($this.is('.playing')) {
                        $this.find('iframe').remove();
                        $this.removeClass('playing');
                    }
                })
            }
        }

    });
});
